import * as React from 'react';

// tslint:disable:max-line-length
export const VideoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
    <path
      fill="#FFF"
      fillRule="nonzero"
      d="M30 0C13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30 16.569 0 30-13.431 30-30C59.981 13.44 46.56.019 30 0zm15.5 30.864l-24 14A1 1 0 0 1 20 44V16a1 1 0 0 1 1.5-.864l24 14a1 1 0 0 1 0 1.728z"
    />
  </svg>
);
